<template>
  <div class="search__advanced-toggle">
    <button
      class="search__advanced-toggle-button"
      :class="{ active: expanded }"
      @click="toggleAdvanced"
    >
      <slot />
    </button>
  </div>
</template>

<script>
import eventBus from '@/js/util/eventBus'

export default {
  data() {
    return {
      expanded: false,
    }
  },
  methods: {
    toggleAdvanced() {
      this.expanded = !this.expanded
      eventBus.$emit('search:advanced', this.expanded)
    },
  },
}
</script>
